const getCustomerLastName = (order) => {
  if (!order.customerName || typeof order.customerName !== "string") {
    return "";
  }

  return order.customerName.trim().split(" ").pop() || "";
};

export const sortOrders = (
  orders,
  sortValue,
  deliveryAccessor = (order) => order.delivery
) => {
  if (!orders) return orders;

  const sortedOrders = [...orders];

  switch (sortValue) {
    case "nearest":
    case "farthest": {
      const deliveryTime = (order) => {
        const delivery = deliveryAccessor(order);
        if (/cancel/i.test(order.orderStatus || "") || !delivery)
          return Infinity;
        const season = /^(Spring|Summer|Fall|Autumn|Winter)\s+(\d{4})$/i.exec(
          delivery
        );
        if (season) {
          const months = {
            spring: 2,
            summer: 5,
            fall: 8,
            autumn: 8,
            winter: 11,
          };
          return new Date(
            Number(season[2]),
            months[season[1].toLowerCase()],
            1
          ).getTime();
        }
        const parsed = Date.parse(delivery);
        return Number.isNaN(parsed) ? Infinity : parsed;
      };
      return sortedOrders.sort((first, second) => {
        const firstTime = deliveryTime(first);
        const secondTime = deliveryTime(second);
        if (firstTime === secondTime) return 0;
        if (firstTime === Infinity) return 1;
        if (secondTime === Infinity) return -1;
        return sortValue === "nearest"
          ? firstTime - secondTime
          : secondTime - firstTime;
      });
    }
    case "newest":
      return sortedOrders.sort(
        (a, b) => new Date(b.orderDate) - new Date(a.orderDate)
      );

    case "oldest":
      return sortedOrders.sort(
        (a, b) => new Date(a.orderDate) - new Date(b.orderDate)
      );

    case "customerNameAsc":
      return sortedOrders.sort((a, b) =>
        getCustomerLastName(a).localeCompare(getCustomerLastName(b))
      );

    case "customerNameDesc":
      return sortedOrders.sort((a, b) =>
        getCustomerLastName(b).localeCompare(getCustomerLastName(a))
      );

    default:
      return orders;
  }
};
